export default __webpack_public_path__ + "static/media/trufflehog.3ed3be87.svg";